module.exports = __webpack_public_path__ + "img/opoli.c19a1d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/opoli.svg?y08y5r
// module id = 1087
// module chunks = 0